var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnpublish = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.298 1.25a1.23 1.23 0 0 1 1.228 1.229v11.044a1.227 1.227 0 0 1-1.228 1.227h-7.67a2.149 2.149 0 0 1-2.136-1.935l-.011-.213V3.398A2.148 2.148 0 0 1 4.628 1.25h7.67zm-7.67 10.433a.92.92 0 0 0-.92.92l.004.09a.923.923 0 0 0 .916.83h7.67v-1.84h-7.67zm0-9.204a.92.92 0 0 0-.92.92v7.265c.285-.135.599-.209.92-.209h7.67V2.48h-7.67zm5.216 3.68a.615.615 0 0 1 0 1.228H6.163a.614.614 0 1 1 0-1.228h3.681z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpublish);
export default ForwardRef;